<template>
  <div>
    <label
      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
      :for="inputId"
    >
      {{ title }}
    </label>
    <input
      v-bind:class="{ formElementError: errorMsg }"
      class="inputField focus:outline-none focus:bg-white focus:border-gray-500"
      :id="inputId"
      type="text"
      :placeholder="placeholder"
      :value="value"
      v-on:input="$emit('input', $event.target.value)"
    />
    <p v-if="errorMsg" class="text-red-500 text-xs italic">{{ errorMsg }}</p>
  </div>
</template>

<script>
export default {
  name: "Textfield",
  props: {
    title: String,
    placeholder: String,
    value: String,
    errorMsg: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      inputId: "textfield-" + this.title,
    };
  },
  methods: {},
};
</script>